module.exports = __webpack_public_path__ + "img/medleyhmslogo.9f7b0fe3.png";